import type { JSX } from 'react'

export function IconInboxRead({
  className,
}: {
  className?: string
}): JSX.Element {
  /* Icon from linear.app */
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="lch(40% 1 282.863 / 1)"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.472 1h2.466c.425 0 .769.339.769.757 0 .383-.29.7-.664.75l-.105.006H5.472a1.28 1.28 0 0 0-1.203.829l-.039.126-1.655 6.517-.013.057h2.303c.513 0 .937.387.995.885l.006.117c0 .553.449 1 1.002 1h2.146c.553 0 1-.447 1-1 0-.553.45-1.002 1.002-1.002h2.41l-.016-.066-.82-2.716c-.121-.4.11-.821.518-.94a.772.772 0 0 1 .919.413l.036.096.82 2.716c.058.193.095.39.11.59l.007.2v1.89c0 1.476-1.17 2.683-2.646 2.77l-.171.005H3.817c-1.499 0-2.724-1.152-2.813-2.605L1 12.225v-1.934c0-.152.013-.303.037-.451l.047-.222L2.74 3.1a2.807 2.807 0 0 1 2.558-2.096L5.472 1ZM12 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
    </svg>
  )
}
